import React from "react";

export const MobileComponent = props => {
  return <div id="mobile--container">{props.children}</div>;
};



// WEBPACK FOOTER //
// ./src/components/Mobile/MobileComponent.js